<script lang="ts">
  import Image from '$components/image.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { buildSizes, buildSrcSet, type SizesConfig, type SrcSetConfig } from '$lib/image';
  import { cn } from '$lib/utils';
  import { getImageAttributes, type ImageAttributesOptions } from '$lib/utils/cms';
  import type { ResponsiveImageStoryblok } from '$types/bloks';

  export let image: ResponsiveImageStoryblok;
  export let options: Partial<ImageAttributesOptions> | undefined = undefined;
  export let widths: SrcSetConfig['widths'] | undefined = undefined;
  export let sizes: string | SizesConfig<string> | undefined = undefined;

  let className: string | undefined = undefined;
  export { className as class };
  export let imgClass: string | undefined = undefined;

  $: isDesktopGif = !!(image.desktop_image && /\.gif$/i.test(image.desktop_image.filename));
  $: isMobileGif = !!(image.mobile_image && /\.gif$/i.test(image.mobile_image.filename));

  // Get the sizes attribute for <source>
  const getSizes = (sizes: string | SizesConfig<string> | undefined) =>
    sizes ? (typeof sizes === 'string' ? sizes : buildSizes(sizes)) : '100vw';

  // Get the srcset attribute for <source>
  const getSrcSet = (
    img:
      | ResponsiveImageStoryblok['desktop_image']
      | ResponsiveImageStoryblok['mobile_image']
      | undefined,
    isGif: boolean
  ) => {
    if (!img) return '';
    return isGif
      ? img.filename
      : buildSrcSet({
          loader: ({ width }) =>
            getImageAttributes(img, options ? options : { size: [width, 0] }).src,
          widths: widths ?? [(w) => w]
        });
  };
</script>

<picture class={cn(className)} use:storyblokEditable={image}>
  {#if image.mobile_image?.filename}
    <source
      media="(max-width: 1024px)"
      sizes={getSizes(sizes)}
      srcset={getSrcSet(image.mobile_image, isMobileGif)}
    />
  {/if}

  {#if image.desktop_image?.filename}
    <source sizes={getSizes(sizes)} srcset={getSrcSet(image.desktop_image, isDesktopGif)} />
  {/if}

  <Image
    loading="lazy"
    {...getImageAttributes(image.desktop_image)}
    class={cn(imgClass)}
    {...$$restProps}
  />
</picture>
